var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoinIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.8066 4.2391C9.76185 4.1125 9.6928 3.99737 9.60505 3.89933C9.41841 3.6908 9.14718 3.55957 8.8453 3.55957H8.05634C7.55384 3.55957 7.14648 3.96693 7.14648 4.46942C7.14648 4.897 7.44421 5.26689 7.8619 5.35826L9.06312 5.62103C9.53106 5.72339 9.8646 6.13807 9.8646 6.61707C9.8646 7.18001 9.40824 7.63674 8.8453 7.63674H8.16578C7.72197 7.63674 7.34441 7.3531 7.20448 6.95721",
    stroke: "#0017E7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50586 3.55934V2.54004",
    stroke: "#0017E7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50586 8.65601V7.63672",
    stroke: "#0017E7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50623 10.489C11.2075 10.489 13.3972 8.29926 13.3972 5.59803C13.3972 2.89681 11.2075 0.707031 8.50623 0.707031C5.80501 0.707031 3.61523 2.89681 3.61523 5.59803C3.61523 8.29926 5.80501 10.489 8.50623 10.489Z",
    stroke: "#0017E7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.20393 6.13379C0.828464 6.82607 0.615234 7.61915 0.615234 8.46204C0.615234 11.1631 2.80485 13.3527 5.50586 13.3527C6.27133 13.3527 6.99573 13.1768 7.64085 12.8633",
    stroke: "#0017E7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinIcon);
export default __webpack_public_path__ + "static/media/coin_icon.b16d2e7ef38e4f513ec6307565f2efa4.svg";
export { ForwardRef as ReactComponent };